
import React from 'react';
import { useStore } from '@src/contexts/store';
import { X } from 'lucide-react';
import * as classes from './index.module.css';

const AlertStack = () => {
  const [store, dispatch] = useStore();
  const { alerts } = store;

  return (
    <div className={classes.alertStackContainer}>
      {alerts.map((alert) => (
        <div
          key={alert.id}
          className={`${classes.alertItem} ${
            alert.type === 'success'
              ? 'bg-green-50 border-green-500 text-green-800'
              : alert.type === 'error'
              ? 'bg-red-50 border-red-500 text-red-800'
              : 'bg-blue-50 border-blue-500 text-blue-800'
          }`}
        >
          <div className={classes.alertContent}>
            <p className={classes.alertTitle}>{alert.title || alert.type}</p>
            {alert.message && <p className={classes.alertMessage}>{alert.message}</p>}
          </div>
          <button
            onClick={() => dispatch({ type: 'DISMISS_ALERT', id: alert.id })}
            className={classes.alertDismissButton}
          >
            <X className={classes.alertDismissIcon} />
          </button>
        </div>
      ))}
    </div>
  );
};

export default AlertStack;